"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get END_MARKER_PREFIX () {
        return END_MARKER_PREFIX;
    },
    get START_MARKER_PREFIX () {
        return START_MARKER_PREFIX;
    },
    get endMarker () {
        return endMarker;
    },
    get startMarker () {
        return startMarker;
    }
});
const START_MARKER_PREFIX = "## WORKER:START:";
const END_MARKER_PREFIX = "## WORKER:END:";
function startMarker(id) {
    return `${START_MARKER_PREFIX}${id}`;
}
function endMarker(id) {
    return `${END_MARKER_PREFIX}${id}`;
}
